import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { DOCUMENT_STATUS } from '../../../../../utils/constant';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const symbols = new Map();
symbols.set(DOCUMENT_STATUS.ALMOST_EXPIRED, 'symbol-status-warning');
symbols.set(DOCUMENT_STATUS.AWAITING_COMPLETION, 'symbol-status-cross');
symbols.set(DOCUMENT_STATUS.AWAITING_GATHERING, 'symbol-status-clock');
symbols.set(DOCUMENT_STATUS.AWAITING_SIGNATURE, 'symbol-status-cross');
symbols.set(DOCUMENT_STATUS.AWAITING_VALIDATION, 'symbol-status-clock');
symbols.set(DOCUMENT_STATUS.CREATED, 'symbol-status-clock');
symbols.set(DOCUMENT_STATUS.EXPIRED, 'symbol-status-cross');
symbols.set(DOCUMENT_STATUS.MISSING, 'symbol-status-cross');
symbols.set(DOCUMENT_STATUS.NOT_APPLICABLE, 'symbol-status-not-applicable');
symbols.set(DOCUMENT_STATUS.REJECTED, 'symbol-status-cross');
symbols.set(DOCUMENT_STATUS.SIGNED, 'symbol-status-check');
symbols.set(DOCUMENT_STATUS.VALID, 'symbol-status-check');
export const DocumentState = props => {
  const state = props.document.state ? DOCUMENT_STATUS[props.document.state] : DOCUMENT_STATUS.MISSING;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-container",
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        width: '20%'
      },
      "data-id": "symbol",
      className: 'symbol ' + symbols.get(state)
    }), /*#__PURE__*/_jsx("div", {
      style: {
        width: '80%'
      },
      children: /*#__PURE__*/_jsx(Translate, {
        value: 'request.documents.ofaStates.' + state
      })
    })]
  });
};
DocumentState.propTypes = {
  document: PropTypes.object.isRequired
};
export default DocumentState;